import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId } from '@repo/store/maps/slices/mapData';
import { useCallback } from 'react';
import type { ChecklistFeedbackSource, ChecklistFeedbackType } from './checklist-feedback';
interface ExtraParams {
  anchorLocationId?: string;
  subcategoryId?: string;
}

/**
 * Shared handler for the `game_map_checklist_feedback` event. Returns a stable callback
 * that packages map + host + caller-provided context and forwards the user's thumb rating.
 */
export function useChecklistFeedback(source, t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const extras = t1;
  const analytics = useAnalytics();
  const hostType = useHostType();
  const externalMapId = useAppSelector(selectExternalMapId);
  const {
    anchorLocationId,
    subcategoryId
  } = extras;
  let t2;
  if ($[2] !== analytics || $[3] !== anchorLocationId || $[4] !== externalMapId || $[5] !== hostType || $[6] !== source || $[7] !== subcategoryId) {
    t2 = type => {
      if (!analytics || !hostType) {
        return;
      }
      analytics.event("game_map_checklist_feedback", {
        mapId: externalMapId ?? undefined,
        source,
        type,
        platform: hostType,
        anchorLocationId,
        subcategoryId
      });
    };
    $[2] = analytics;
    $[3] = anchorLocationId;
    $[4] = externalMapId;
    $[5] = hostType;
    $[6] = source;
    $[7] = subcategoryId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}